export default {
  auto: 'Auto',
  signals: 'Signals',
  axes: 'Axes',
  axesHeader: {
    displayName: 'Axis label',
    chartScaleType: 'Axis type',
    position: 'Axis position',
    limitMin: 'Min limit',
    limitMax: 'Max limit',
    defaultUnitOfMeasure: 'Unit of measure',
    signalCount: 'Signal count',
    delete: '',
  },
  deleteAxisConfirmation: {
    title: 'Delete Axis',
    message: 'This axis contains {count} signal(s). All these signals will be deleted as well. Are you sure you want to delete it?',
  },
};
